import { AppForm } from '../../../../../../common/forms/app.form';
import {
  AbstractControl,
  AbstractControlOptions,
  AsyncValidatorFn,
  FormControl,
  ValidatorFn,
  Validators
} from '@angular/forms';

export interface RoadControlsFormValue {
  roadName: string;
  roadNumber: string;
  street: string;
}

export class RoadControlsForm extends AppForm {
  constructor(
    controls: {
      [key: string]: AbstractControl;
    },
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    super({
      ...controls,
      roadNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      roadName: new FormControl({ value: '', disabled: true }, {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      street: new FormControl(null, [Validators.maxLength(255)])
    }, validatorOrOpts, asyncValidator);
  }

  public get roadNumber(): FormControl {
    return this.get('roadNumber') as FormControl;
  }

  public get roadName(): FormControl {
    return this.get('roadName') as FormControl;
  }

  public get street(): FormControl {
    return this.get('street') as FormControl;
  }
}
